import { useState, useEffect, useRef } from "react";
import axios from "axios";

import { getCaseId, getClientId, getToken } from "../../Utils/helper";
import api, { api_without_cancellation } from "../../api/api";
import { useDocumentModal } from "../common/CustomModal/CustomModalContext";
import CourtFormModalSideBar from "../CourtForm/CourtFormSideBar/CourtFormModalSideBar";

import WPDiscoveryDraftBase from "./WPDiscoveryDraftBase";
import SendEmailPopUp from "./SendEmailPopUp";

function WPDiscoveryDraft({
  docId,
  updatedDocId,
  dynamicTemplateId,
  dispatch,
  state,
  fetchEditDocs,
  _type,
  litigationId,
  showRightSidebar,
  _setTotalPages,
  _setPageNumber,
}) {
  const origin = process.env.REACT_APP_BACKEND_URL;

  const container = useRef(null);

  const [docName, setDocName] = useState(null);
  const [docData, setDoctData] = useState(null);
  const [pageId, setPageId] = useState(null);
  const [emailPopUp, setEmailPopUp] = useState(false);

  const [_saveLoading, setSaveLoading] = useState(false);

  // eslint-disable-next-line unused-imports/no-unused-vars
  const [dropdownId, setDropdownId] = useState(null);

  // New
  const currentCaseId = getCaseId();
  const token = getToken();
  const [slotsData, setSlotsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pages, setPages] = useState([]);
  const { documentData, refetchDocumentData } = useDocumentModal();

  useEffect(() => {
    const fetchDataFirstTime = async () => {
      try {
        const response = await axios.get(
          `${origin}/api/general/get-attach-menu/?case_id=${Object.keys(docData).length ? docData?.for_case?.id : currentCaseId}&client_id=${Object.keys(docData).length ? docData?.for_client?.id : getClientId()}`,
          {
            // params: {
            //   page_id: "",
            //   case_id: Object.keys(docData).length ? docData?.for_case?.id : currentCaseId,
            //   all_docs: "True",
            //   client_id: Object.keys(docData).length ? docData?.for_client?.id : getClientId(),
            // },
            headers: {
              Authorization: token,
            },
          }
        );
        if (response.status === 200) {
          setSlotsData(response.data.data);
          setLoading(false);
        }
      } catch (error) {
        console.error(error);
      }
    };
    if (token) {
      fetchDataFirstTime();
    }
  }, [currentCaseId, docData, token]);

  const fetchPageDetails = async (caseId) => {
    try {
      const response = await axios.get(`${origin}/api/pages/${caseId}/`, {
        headers: {
          Authorization: token,
        },
      });
      setPages(response.data);
    } catch (error) {
      console.error("Error occurred while fetching pages", error);
    }
  };

  useEffect(() => {
    setPages([]);
    if (docData?.for_case?.id) {
      fetchPageDetails(docData?.for_case?.id);
    }
  }, [docData]);

  const abortControllerRef = useRef(null);
  const refetchSlotsData = async () => {
    // Abort the previous request
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    // Create a new controller
    const controller = new AbortController();
    abortControllerRef.current = controller;

    try {
      const response = await axios.get(
        `${origin}/api/general/get-attach-menu/?case_id=${Object.keys(docData).length ? docData?.for_case?.id : currentCaseId}&client_id=${Object.keys(docData).length ? docData?.for_client?.id : getClientId()}`,
        {
          // params: {
          //   page_id: "",
          //   case_id: docData?.for_case?.id || "",
          //   all_docs: "True",
          //   client_id: docData?.for_client?.id || "",
          // },
          signal: controller.signal,
          headers: {
            Authorization: token,
          },
        }
      );

      if (response.status === 200) {
        setSlotsData(response.data.data);
      }
    } catch (error) {
      if (error.name === "CanceledError") {
        console.error("Previous API call aborted.");
      } else {
        console.error("API error:", error);
      }
    }
  };

  // New End

  useEffect(() => {
    getDocNameAndPageId();
  }, []);

  const deleteEditDoc = async () => {
    try {
      const formData = new FormData();
      formData.append("doc_id", docId);

      const response = await api_without_cancellation.post(
        `${origin}/api/delete-edit-doc/`,
        formData
      );
      if (response.status === 200) {
        if (response.data.success) {
          fetchEditDocs();
        }
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const getDocNameAndPageId = async () => {
    try {
      const response = await axios.get(`${origin}/api/getDocFile/?doc_id=${docId}`, {
        headers: {
          Authorization: getToken(),
        },
      });
      if (response.status === 200) {
        setDocName(response.data.file_name);
        setPageId(response.data.page_id);
      }

      // }
    } catch (error) {
      dispatch({ type: "SET_ERROR", payload: true });
    }
  };

  const attachPdfToCaseFile = async () => {
    setSaveLoading(true);
    const content = await container.current?.documentEditor.saveAsBlob("Docx");
    const renamedFile = new File([content], `${docName}.docx`, {
      type: content.type,
    });

    const formData = new FormData();
    formData.append("file", renamedFile);
    formData.append("case_id", getCaseId());
    formData.append("client_id", getClientId());
    formData.append("panel_id", litigationId);

    try {
      const response = await api.post(
        `${origin}/api/documents/pdf-to-casefile-litigation/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.status === 200) {
        const { data, filename } = response.data;
        const pdfBlob = new Blob([Uint8Array.from(atob(data), (c) => c.charCodeAt(0))], {
          type: "application/pdf",
        });
        const url = URL.createObjectURL(pdfBlob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);

        await deleteEditDoc();
      }
    } catch (error) {
      console.error("Error printing document:", error);
    } finally {
      setSaveLoading(false);
    }
  };

  const controls = (
    <>
      {docData && (
        <CourtFormModalSideBar
          docData={docData}
          documentData={documentData}
          pages={pages}
          slotsData={slotsData}
          onRefetchSlotsData={refetchSlotsData}
          loading={loading}
          setSlotsData={setSlotsData}
          refetchDocumentData={refetchDocumentData}
          litigationId={litigationId}
          docId={docId}
          fetchEditDocs={fetchEditDocs}
          dispatch={dispatch}
          type="Draft"
          container={container}
          docName={docName}
          state={state}
          pageId={pageId}
        />
      )}
    </>
  );

  const handleCloseEmailPopUp = () => {
    setEmailPopUp(false);
  };

  return (
    <>
      <WPDiscoveryDraftBase
        docId={docId}
        updatedDocId={updatedDocId}
        dynamicTemplateId={dynamicTemplateId}
        setPageId={setPageId}
        setDropdownId={setDropdownId}
        setDocName={setDocName}
        setDoctData={setDoctData}
        state={state}
        dispatch={dispatch}
        container={container}
        controls={controls}
        type="Draft"
        showRightSidebar={showRightSidebar}
      />

      <SendEmailPopUp
        emailPopUp={emailPopUp}
        handleCloseEmailPopUp={handleCloseEmailPopUp}
        attachPdfToCaseFile={attachPdfToCaseFile}
        container={container}
        docName={docName}
      />
    </>
  );
}

export default WPDiscoveryDraft;
